import { useMemo } from 'react';

import { Column, Table } from '@tanstack/react-table';

interface FilterProps {
  column: Column<any, any>;
  table: Table<any>;
}

type NumberFilterProps = Omit<FilterProps, 'table'>;
interface StringFilterProps extends Omit<FilterProps, 'table'> {
  showList?: boolean;
}

const NumberFilter: React.FunctionComponent<NumberFilterProps> = function ({
  column,
}) {
  return (
    <div className="flex space-x-2">
      <input
        type="number"
        value={((column.getFilterValue() as any)?.[0] ?? '') as string}
        onChange={(e) =>
          column.setFilterValue((old: any) => [e.target.value, old?.[1]])
        }
        placeholder="Min"
        className="min-w-24 w-1/2 border border-neutral-300 rounded text-16-24"
      />
      <input
        type="number"
        value={((column.getFilterValue() as any)?.[1] ?? '') as string}
        onChange={(e) =>
          column.setFilterValue((old: any) => [old?.[0], e.target.value])
        }
        placeholder="Max"
        className="min-w-24 w-1/2 border border-neutral-300 rounded text-16-24"
      />
    </div>
  );
};

const StringFilter: React.FunctionComponent<StringFilterProps> = function ({
  column,
  showList,
}) {
  const uniqueValues = useMemo(() => column.getFacetedUniqueValues(), [column]);
  const sortedUniqueValues = useMemo(
    () => Array.from(uniqueValues.keys()).sort(),
    [uniqueValues],
  );

  if (!showList)
    return (
      <input
        type="text"
        value={(column.getFilterValue() ?? '') as string}
        onChange={(e) => column.setFilterValue(e.target.value)}
        placeholder="Search..."
        className="min-w-36 border border-neutral-300 rounded text-16-24 w-full"
      />
    );
  return (
    <>
      <datalist id={`${column.id}list`}>
        {sortedUniqueValues.map((value: any) => (
          <option value={value} key={value}>
            {value}
          </option>
        ))}
      </datalist>
      <input
        type="text"
        value={(column.getFilterValue() ?? '') as string}
        onChange={(e) => column.setFilterValue(e.target.value)}
        placeholder={`Search... (${uniqueValues.size})`}
        className="min-w-36 border border-neutral-300 rounded text-16-24 w-full"
        list={`${column.id}list`}
      />
    </>
  );
};

const Filter: React.FunctionComponent<FilterProps> = function ({
  column,
  table,
}) {
  const firstValue = table
    .getPreFilteredRowModel()
    .flatRows[0]?.getValue(column.id);

  if (typeof firstValue === 'number') return <NumberFilter column={column} />;
  return <StringFilter column={column} showList={false} />;
};

export default Filter;
